/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { checkCrefoVersions } from '../fn/crefo-version-controller/check-crefo-versions';
import { CheckCrefoVersions$Params } from '../fn/crefo-version-controller/check-crefo-versions';

@Injectable({ providedIn: 'root' })
export class CrefoVersionControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `checkCrefoVersions()` */
  static readonly CheckCrefoVersionsPath = '/crefo/versions/check';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `checkCrefoVersions()` instead.
   *
   * This method doesn't expect any request body.
   */
  checkCrefoVersions$Response(params?: CheckCrefoVersions$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return checkCrefoVersions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `checkCrefoVersions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  checkCrefoVersions(params?: CheckCrefoVersions$Params, context?: HttpContext): Observable<void> {
    return this.checkCrefoVersions$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
